import { render, staticRenderFns } from "./ColorAndTextTag.vue?vue&type=template&id=ddd7d364&scoped=true"
import script from "./ColorAndTextTag.vue?vue&type=script&lang=js"
export * from "./ColorAndTextTag.vue?vue&type=script&lang=js"
import style0 from "./ColorAndTextTag.vue?vue&type=style&index=0&id=ddd7d364&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd7d364",
  null
  
)

export default component.exports